
    <h1 mat-dialog-title>Warning!</h1>
    <div style="min-height:130px">
      You've selected {{data.userSelected}} here, but the equipment you've assigned states this system is a {{data.equip}}
    </div>
    <button mat-button (click)="dref.close()"  style="margin-left: 40px;background: #ffffffaf;">Close</button>


  